import React, { Component, Fragment } from 'react'
import ReactDOM from 'react-dom'

/**
 * 用来创建body节点下需要添加DOM容器的高阶组件
 */
export interface PortalProps {
    container?: HTMLElement
}
export default class Portal extends Component<PortalProps, any> {

    wrapper: HTMLElement
    el: HTMLElement
    constructor(props) {
        super(props)

        this.wrapper = props.container || document.body
        this.el = document.createElement('div')
        this.el.style = 'position: absolute; top: 0px; left: 0px; width: 100%;zIndex:9999'
    }

    render() {
        return ReactDOM.createPortal(
            <Fragment>
                {this.props.children}
            </Fragment>,
            this.el
        )
    }

    componentDidMount() {
        this.wrapper.appendChild(this.el)
    }

    componentWillUnmount() {
        this.wrapper.removeChild(this.el)
    }

}